import {CatalogPageModel} from '../Model/CatalogModel';
import {CatalogPageEntity, CatalogPageEntityData} from '../Entity/CatalogPageEntity';

export const catalogPageMapper = (data: CatalogPageModel): CatalogPageEntity => {
  const catalogPageEntityData: CatalogPageEntityData = {
    img: data.img
  };

  return new CatalogPageEntity(catalogPageEntityData);
};
